import baseOC, { buildEmptyObjectContainer } from "icfrontendbase";
import apiClientOC from "icfrontendapiclient";
import { ApiCallStorage } from "../request/apiCallStorage/ApiCallStorage";
import { ApiCallStorageReader } from "../request/apiCallStorageReader/ApiCallStorageReader";
const buildOC = () => {
  const libOC = buildEmptyObjectContainer();

  // #####################################################################################################################
  // Future note: the uiOC should extend the baseOC and apiClientOC (instead of manually setting each template like this)
  //                  that could be done by adding a "merge" or "extend" method in the OC class to combine OCs
  const _build_ConfigStorage = (container, parent) => {
    const configStorage = baseOC.get("ConfigStorage");
    configStorage.set("bizapi_url_base", "/business/proxy/product");
    return configStorage;
  };
  libOC.set("ConfigStorage", _build_ConfigStorage);
  const _build_SharedStorageInitValue = (container, parent) => {
    const sharedStorageInitValue = baseOC.get("SharedStorageInitValue");
    return sharedStorageInitValue;
  };
  libOC.set("SharedStorageInitValue", _build_SharedStorageInitValue);
  const _build_SharedStorageReduxReducersGenerator = (container, parent) => {
    const sharedStorageReduxReducersGenerator = baseOC.get("SharedStorageReduxReducersGenerator");
    return sharedStorageReduxReducersGenerator;
  };
  libOC.set("SharedStorageReduxReducersGenerator", _build_SharedStorageReduxReducersGenerator);
  const _build_SharedStorage = (container, parent) => {
    const sharedStorage = baseOC.get("SharedStorage");
    return sharedStorage;
  };
  libOC.set("SharedStorage", _build_SharedStorage);
  // #####################################################################################################################

  const _build_ApiCallStorage = (container, parent) => {
    return new ApiCallStorage();
  };
  libOC.set("ApiCallStorage", _build_ApiCallStorage);
  const _build_ApiCallStorageReader = (container, parent) => {
    return new ApiCallStorageReader(container.get("ApiCallStorage"), apiClientOC.get("BizApiClient"), container.get("SharedStorage"), apiClientOC.get("BizApiErrorInterpreter"));
  };
  libOC.set("ApiCallStorageReader", _build_ApiCallStorageReader);
  return libOC;
};
export default buildOC;